import { IndexBreedsScreen, IndexBreedsScreenProps } from 'shared/screens/breeds/index-breeds';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { Animal, Breed, Characteristic } from 'shared/@generated/models';
import {
  BreedsFilter,
  parseBreedsFilter,
  shouldNoIndexBreedsFilter,
} from 'shared/state/breeds-filter';
import { PageBuilder } from 'shared/library/page-builder';
import { Paginator } from 'shared/@types';
import { apiRoute } from 'shared/library/api-route';
import { prepareDataForApi } from 'shared/library/api-client';

export default function MediumDogBreeds(props: IndexBreedsScreenProps) {
  const { t } = useTranslation('screens');
  const title = t(`breeds.index_breeds.medium_dog_title`);
  const description = t(`breeds.index_breeds.medium_dog_description`);

  return (
    <Page
      {...props}
      register={(seo) => {
        const pageSeo = seo
          .setTitle(title)
          .setDescription(description)
          .setPagination(props.initialBreeds);

        return shouldNoIndexBreedsFilter(props.initialFilter, ['animal', 'size'])
          ? pageSeo.setNoIndex()
          : pageSeo;
      }}
    >
      <IndexBreedsScreen
        {...props}
        lockedFilter={{ animal: Animal.Dog, size: Characteristic.SizeMedium }}
        title={title}
        description={description}
      />
    </Page>
  );
}

const pageBuilder = new PageBuilder<IndexBreedsScreenProps, BreedsFilter>().request(
  ({ req, params }) => {
    const filter = {
      ...parseBreedsFilter(params),
      animal: Animal.Dog,
      size: Characteristic.SizeMedium,
    };

    return req<{ breeds: Paginator<Breed> }>(apiRoute('breeds.index'), {
      ...prepareDataForApi(filter, ['characteristics']),
      with_details: true,
    }).then((data) => ({
      initialBreeds: data.breeds,
      initialFilter: filter,
    }));
  },
);

export const getServerSideProps = withServerProps(pageBuilder);
